module.exports = __webpack_public_path__ + "img/happytable_info4.15d0712e.jpg";